import React from "react";
import classes from "./footerbar.module.css";
const Footerbar = () => {
  return (
    <div className={classes.footerdiv}>
      <center>
        <p>
          © 2021 MovieStar - 300mb Movies, 720p Movies, Hindi Dubbed Series,
          1080p Movies, 480p Movies, 500mb Movies, 900mb Movies, Tv series,
          MovieStar
	  <br/>
	  Made with ❤💛 by Movie⭐ Team
        </p>
      </center>
    </div>
  );
};

export default Footerbar;
